import { render } from "./TicketList.vue?vue&type=template&id=45f2cfc8"
import script from "./TicketList.vue?vue&type=script&lang=js"
export * from "./TicketList.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__